import { X } from '@phosphor-icons/react';
import { ModalResourceItem } from '../../../../../types/apiTypes';

interface ResourceDetailModalProps {
  item: ModalResourceItem | null;
  onClose: () => void;
}

function ResourceDetailModal({ item, onClose }: ResourceDetailModalProps) {
  if (!item) return null;

  const handleCtaClick = () => {
    if (item.modalContent.cta?.url) {
      window.open(item.modalContent.cta.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-lg rounded-xl bg-white p-6 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 flex h-8 w-8 items-center justify-center rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-900"
          aria-label="Close modal"
        >
          <X size={20} weight="bold" />
        </button>

        <div className="flex flex-col items-start gap-4">
          {item.logoUrl && (
            <img
              src={item.logoUrl}
              alt={`${item.name} logo`}
              className="h-16 w-16 rounded-lg object-contain"
            />
          )}
          <h2 className="text-2xl font-semibold text-gray-900">{item.name}</h2>
          <p className="whitespace-pre-wrap text-sm text-gray-700">
            {item.modalContent.longDescription}
          </p>
          {item.modalContent.cta && (
            <button
              onClick={handleCtaClick}
              className="mt-2 rounded-lg bg-ctadarkgreen px-4 py-2 text-sm font-semibold text-white hover:bg-opacity-90"
            >
              {item.modalContent.cta.label}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default ResourceDetailModal;
